/* RESPONSIBLE TEAM: team-app-security */

export const SCIM_TRANSLATION_KEYS = {
  TAB: {
    TITLE: 'new-settings.workspace.teammates.scim-tab.title',
    DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.description',
    DRAG_TO_REORDER: 'new-settings.workspace.teammates.scim-tab.drag-to-reorder',
    NO_ROLES_AVAILABLE: 'new-settings.workspace.teammates.scim-tab.no-roles-available',
    NO_ROLE_ASSIGNED: 'new-settings.workspace.teammates.scim-tab.no-role-assigned',
    UNKNOWN_ROLE: 'new-settings.workspace.teammates.scim-tab.unknown-role',
    USERS_COUNT_SHORT: 'new-settings.workspace.teammates.scim-tab.users-count-short',
    USERS_COUNT: 'new-settings.workspace.teammates.scim-tab.users-count',
    USER_ACTIVE: 'new-settings.workspace.teammates.scim-tab.user-active',
    USER_INACTIVE: 'new-settings.workspace.teammates.scim-tab.user-inactive',
    CREATED_AT: 'new-settings.workspace.teammates.scim-tab.created-at',
    UPDATED_AT: 'new-settings.workspace.teammates.scim-tab.updated-at',
    ROLE_ASSIGNMENT: 'new-settings.workspace.teammates.scim-tab.role-assignment',
    ROLE_ASSIGNMENT_DESCRIPTION:
      'new-settings.workspace.teammates.scim-tab.role-assignment-description',
    ASSIGNED_ROLE: 'new-settings.workspace.teammates.scim-tab.assigned-role',
    USERS_IN_GROUP: 'new-settings.workspace.teammates.scim-tab.users-in-group',
    NO_ROLES_MESSAGE: 'new-settings.workspace.teammates.scim-tab.no-roles-message',
    CREATE_ROLES_FIRST: 'new-settings.workspace.teammates.scim-tab.create-roles-first',
    NO_USERS_TITLE: 'new-settings.workspace.teammates.scim-tab.no-users-title',
    NO_USERS_DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.no-users-description',
    DETAILS_LOAD_ERROR: 'new-settings.workspace.teammates.scim-tab.details-load-error',
    LOAD_ERROR: 'new-settings.workspace.teammates.scim-tab.load-error',
  },
  TABLE: {
    PRIORITY: 'new-settings.workspace.teammates.scim-tab.table.priority',
    GROUP_NAME: 'new-settings.workspace.teammates.scim-tab.table.group-name',
    ROLE: 'new-settings.workspace.teammates.scim-tab.table.role',
    USERS: 'new-settings.workspace.teammates.scim-tab.table.users',
  },
  ACTIONS: {
    CANCEL: 'new-settings.workspace.teammates.scim-tab.actions.cancel',
    APPLY_CHANGES: 'new-settings.workspace.teammates.scim-tab.actions.apply-changes',
    APPLY_GROUP_CHANGES: 'new-settings.workspace.teammates.scim-tab.actions.apply-group-changes',
    APPLY_SELECTED_CHANGES:
      'new-settings.workspace.teammates.scim-tab.actions.apply-selected-changes',
    DETAILS: 'new-settings.workspace.teammates.scim-tab.actions.details',
    CLOSE: 'new-settings.workspace.teammates.scim-tab.actions.close',
  },
  NO_GROUPS: {
    TITLE: 'new-settings.workspace.teammates.scim-tab.no-groups.title',
    DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.no-groups.description',
  },
  CHANGES_REVIEW: {
    TITLE: 'new-settings.workspace.teammates.scim-tab.changes-review.title',
    DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.changes-review.description',
    CHANGE: 'new-settings.workspace.teammates.scim-tab.changes-review.change',
    FROM: 'new-settings.workspace.teammates.scim-tab.changes-review.from',
    TO: 'new-settings.workspace.teammates.scim-tab.changes-review.to',
    ORDER_CHANGE_TITLE:
      'new-settings.workspace.teammates.scim-tab.changes-review.order-change-title',
    ORDER_CHANGED: 'new-settings.workspace.teammates.scim-tab.changes-review.order-changed',
    NO_CHANGES_SELECTED:
      'new-settings.workspace.teammates.scim-tab.changes-review.no-changes-selected',
  },
  SUCCESS_MESSAGES: {
    CHANGES_APPLIED: 'new-settings.workspace.teammates.scim-tab.changes-applied-success',
    GROUP_CHANGES_APPLIED:
      'new-settings.workspace.teammates.scim-tab.group-changes-applied-success',
  },
  ERROR_MESSAGES: {
    CHANGES_APPLIED: 'new-settings.workspace.teammates.scim-tab.changes-applied-error',
    GROUP_CHANGES_APPLIED: 'new-settings.workspace.teammates.scim-tab.group-changes-applied-error',
  },
} as const;
